define('common/collections/domains',['require','exports','module','base/collection','../models/domain','env'],function(require, exports, module) {
  "use strict";

  var BaseCollection = require("base/collection"),
      Domain = require("../models/domain"),
      config = require("env");

  module.exports = BaseCollection.extend({
    model: Domain,
    url: config.apiHost + "/domains"
  });

});

